const SUBTITLE_SEPARATOR = ' · '

export function formatExperienceCategoryLabels(
  categories: Array<{ label: string }>,
): string {
  return categories.map((category) => category.label).join(', ')
}

/**
 * Builds the "location · categories" subheading shown under an experience title
 * (in the drawer sticky header, or in content on mobile). Returns undefined when
 * neither piece is available so callers can omit the subtitle entirely.
 */
export function formatExperienceHeaderSubtitle({
  location,
  categories,
}: {
  location?: string
  categories: Array<{ label: string }>
}): string | undefined {
  const categoryLabels = formatExperienceCategoryLabels(categories)
  const parts = [location, categoryLabels].filter(Boolean)
  return parts.length > 0 ? parts.join(SUBTITLE_SEPARATOR) : undefined
}
